function Kosovarspage() {
  return (
    <div className="w-full h-full grid grid-cols-4 p-0 m-0">
      {[...Array(100)].map(() => (
        <div className="w-full border-2 p-16 flex items-center justify-center">
          Here goes text.
        </div>
      ))}
    </div>
  );
}
export default Kosovarspage;
